import { useState, useEffect } from "react"
import { getJson, deleteJson } from "../helpers/http"

const useResourceList = (endpoint, listKey, itemKey) => {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [deletingId, setDeletingId] = useState(null)
  const [loadingId, setLoadingId] = useState(null)

  useEffect(() => {
    let mounted = true
    const fetchItems = async () => {
      const { data, error: apiError } = await getJson(endpoint)
      if (!mounted) return
      setLoading(false)
      if (apiError) {
        setError(apiError)
        return
      }
      setItems(data[listKey] ?? [])
    }
    fetchItems()
    return () => {
      mounted = false
    }
  }, [endpoint, listKey])

  const deleteItem = async (id, name) => {
    if (!confirm(`Delete "${name}"?`)) return
    setDeletingId(id)
    const { error: apiError } = await deleteJson(`${endpoint}/${id}`)
    setDeletingId(null)
    if (apiError) {
      setError(apiError)
      return
    }
    setItems((prev) => prev.filter((item) => item.id !== id))
  }

  const loadItem = async (id) => {
    setLoadingId(id)
    setError(null)
    const { data, error: apiError } = await getJson(`${endpoint}/${id}`)
    setLoadingId(null)
    if (apiError) {
      setError(apiError)
      return null
    }
    return data[itemKey]
  }

  const isItemBusy = (id) => loadingId === id || deletingId === id

  return { items, loading, error, deletingId, loadingId, deleteItem, loadItem, isItemBusy }
}

export default useResourceList
